(() => {
	angular
		.module('main')
		.controller('AddWorkflowController', AddWorkflowController);

	AddWorkflowController.$inject = [
		'$scope',
		'$location',
		'$routeParams',
		'messageService',
		'workflowDragNDropService',
		'workflowService',
		'templateRequestsService',
		'randomStringGenerator',
		'newWorkflowService',
		'settingsService'
	];

	function AddWorkflowController(
		$scope,
		$location,
		$routeParams,
		messageService,
		workflowDragNDropService,
		workflowService,
		templateRequestsService,
		randomStringGenerator,
		newWorkflowService,
		settingsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.templates = {};
			$scope.isExitModalOpen = false;
			subscribeToCustomizeLabelsChange().subscribe(customizeLabels => {
				$scope.mainShootLabelName = customizeLabels.mainShootLabel;
				$scope.extraShootLabelName = customizeLabels.extraShootLabel;
				$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				$scope.lists = createDefaultList();
			});

			Rx.Observable.zip(
				templateRequestsService.getTemplates('contract_preview'),
				templateRequestsService.getTemplates('questionnaire_preview'),
				templateRequestsService.getTemplates('general_preview')
			).subscribe(
				([contracts, questionnaires, general]) => {
					setContractsPreview(contracts);
					setQuestionnairesPreview(questionnaires);
					setGeneralEmailsPreview(general);
				},
				error => showErrorMessage()
			);

			$scope.isSaveSpinningWheelActive = false;

			if ($routeParams.id) {
				workflowService.getTaskTemplates($routeParams.id, successGetTemplates);
				return;
			}

			$scope.newWorkflow = {
				name: ''
			};

			$scope.unsubscribe = new Rx.Subject();
		});

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.$on('$routeChangeStart', (event, next) => {
			$scope.currentWorkflowCopy = gatherData();
			if (
				!$scope.isExitModalOpen &&
				!angular.equals($scope.currentWorkflow, $scope.currentWorkflowCopy)
			) {
				event.preventDefault();
				$('#workflowExitModal').modal('show');
			}
			$scope.nextPage = next.$$route.originalPath;
		});

		$scope.taskTypes2Show = ['LEAD', 'PRODUCTION', 'POST-PRODUCTION'];

		$scope.isLabelShown = newWorkflowService.isLabelShown;

		$scope.onChangePage = function(isLeavePage) {
			if (
				(typeof $scope.newWorkflow.name !== 'undefined' &&
					$scope.newWorkflow.name !== '') ||
				!isLeavePage
			) {
				$scope.isExitModalOpen = true;
			}
			if (isLeavePage === true) {
				$scope.save();
			} else {
				$location.path($scope.nextPage);
			}
		};

		$scope.setLabeledViewDue = function(viewDue) {
			return viewDue.includes('main shoot')
				? viewDue.replace('main shoot', $scope.mainShootLabelName.toLowerCase())
				: viewDue;
		};

		function subscribeToCustomizeLabelsChange() {
			return settingsService.customizeLabelsObservable;
		}

		function showErrorMessage() {
			messageService.showToaster('e_0', 'general');
		}

		function setContractsPreview(data) {
			$scope.templates.contractEmailTemplates = angular.copy(
				data.emailTemplates
			);
			$scope.templates.contracts = angular.copy(data.contractTemplates);
		}

		function setQuestionnairesPreview(data) {
			$scope.templates.questionnaireEmailTemplates = angular.copy(
				data.emailTemplates
			);
			$scope.templates.questionnaires = angular.copy(
				data.questionnaireTemplates
			);
		}

		function setGeneralEmailsPreview(data) {
			$scope.templates.generalEmailTemplates = angular.copy(data);
		}

		function createDefaultList() {
			const list = addDefaultTasks();
			return workflowService.fillWorkflowTasks(list);
		}

		function addDefaultTasks() {
			const defaultTaskNames = [
				'Lead created',
				'Job accepted',
				$scope.mainShootLabelName,
				'Job complete'
			];

			const defaultTaskTypes = [
				'LEAD',
				'PRODUCTION',
				'PRODUCTION',
				'POST_PRODUCTION'
			];
			return Array.from(new Array(4), (item, index) => ({
				name: defaultTaskNames[index],
				type: defaultTaskTypes[index],
				eventType: index === 2 ? 'MAIN_SHOOT' : null,
				defaultTask: true,
				number: index
			}));
		}

		function handleTaskTemplates(task, taskTypes) {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}
			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}
			if (!task.action && task.emailTemplate) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}
			if (task.emailTemplate) {
				task.taskEmail = angular.copy(task.emailTemplate);
				delete task.emailTemplate;
			}
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
		}

		function successGetTemplates(workflow) {
			const workflowCopy = angular.copy(workflow);

			const path = $location.path();

			if (path.includes('duplicate')) {
				workflowCopy.id = null;
				workflowCopy.taskTemplates.forEach(item => (item.id = null));
			}

			$scope.newWorkflow = workflowCopy;

			const taskList = $scope.newWorkflow.taskTemplates;
			$scope.lists = workflowService.fillWorkflowTasks(taskList);
			taskList.forEach(item => handleTaskTemplates(item, $scope.lists));
			adjustLabelsToWorkflow(taskList);
			$scope.currentWorkflow = gatherData();
		}

		function adjustLabelsToWorkflow(workflowCopy) {
			workflowCopy.forEach(item => {
				if (
					item.eventType === 'MAIN_SHOOT' &&
					(item.name && item.name.toLowerCase().includes('main shoot'))
				) {
					item.name = $scope.mainShootLabelName;
				}
			});
		}

		$scope.showAddNewTaskModal = () => {
			$('#addWorkflowTaskModal').modal('show');
		};

		function isWorkflowValid(workflow) {
			const workflowName = workflow.name || '';
			if (!workflowName && !workflowName.trim()) {
				messageService.showToaster('e_0', 'workflow');
				return false;
			}
			return true;
		}

		function clearDueInfo(task2Save) {
			task2Save.due = null;
			task2Save.dateItem = null;
			task2Save.dateSequence = null;
			return task2Save;
		}

		function prepareTaskEmail(taskEmail, task2Save) {
			let emailTemplate = {};
			const {
				id,
				name,
				subject,
				text,
				base64Attachments,
				storedAttachments
			} = taskEmail;

			if (id || id === 0) {
				emailTemplate = { id };
			} else {
				emailTemplate = {
					name,
					subject,
					text,
					base64Attachments,
					storedAttachments
				};
			}

			task2Save.emailTemplate = emailTemplate;
			delete task2Save.taskEmail;

			return task2Save;
		}

		function prepareTasksToSave(task) {
			let task2Save = angular.copy(task);
			const { hasDue, tmpId, taskEmail } = task2Save;

			if (!hasDue) {
				task2Save = clearDueInfo(task2Save);
			}

			if (taskEmail) {
				task2Save = prepareTaskEmail(taskEmail, task2Save);
			}

			if (tmpId) {
				delete task2Save.tmpId;
			}

			return task2Save;
		}

		function successSaveWorkflow(data, workflow) {
			const path = $location.path();
			toastr.clear();
			if (path.includes('edit')) {
				messageService.showToaster('s_0', 'workflow', workflow.name);
			} else {
				messageService.showToaster('s_1', 'workflow', workflow.name);
			}

			if ($scope.nextPage) {
				$location.path($scope.nextPage);
			} else {
				$location.path('/settings/workflows');
			}
		}

		$scope.save = () => {
			if (
				typeof $scope.newWorkflow.name !== 'undefined' &&
				$scope.newWorkflow.name !== ''
			) {
				$scope.isExitModalOpen = true;
			}
			$scope.button_disabled = true;
			$scope.isSaveSpinningWheelActive = true;
			const workflow = $scope.newWorkflow;

			if (!isWorkflowValid(workflow)) {
				$scope.button_disabled = false;
				$scope.isSaveSpinningWheelActive = false;
				return;
			}

			const data2Save = gatherData();
			const tasks2Save = data2Save.taskTemplates.map(prepareTasksToSave);
			data2Save.taskTemplates = tasks2Save;

			workflowService
				.saveWorkflowTemplate(data2Save, successSaveWorkflow)
				.finally(() => {
					$scope.button_disabled = false;
					$scope.isSaveSpinningWheelActive = false;
				})
				.subscribe();
		};

		function gatherData() {
			delete $scope.newWorkflow.taskTemplates;
			let workflow2Save = angular.copy($scope.lists);
			workflow2Save = workflowDragNDropService.renewTaskList(workflow2Save);
			const taskTemplates = [].concat.apply([], workflow2Save);
			return {
				id: $scope.newWorkflow.id,
				name: $scope.newWorkflow.name,
				taskTemplates,
				taskToDelete: $scope.newWorkflow.taskToDelete
			};
		}

		// drag'n'drop
		let lastCorrectOrder;
		$scope.onDragStart = () => {
			lastCorrectOrder = angular.copy($scope.lists);
		};

		$scope.onDragOver = type => {
			if (type && type.toUpperCase() === 'MAIN_SHOOT') {
				$('.dndPlaceholder').addClass('mainShootOver');
			} else {
				$('.dndPlaceholder').removeClass('mainShootOver');
			}
			return true;
		};

		$scope.onDragend = task => {
			const draggedTask = workflowService.getTaskByNumber(
				task.number,
				$scope.lists
			);

			if (!draggedTask.id) {
				draggedTask.tmpId = randomStringGenerator.getMixedString();
			}

			$scope.lists = workflowDragNDropService.keepDefaultTasksInPlace(
				$scope.lists
			);

			const renewedList = workflowDragNDropService.renewTaskList($scope.lists);
			const newTaskInfo = workflowDragNDropService.getTaskById(
				draggedTask,
				renewedList
			);
			const isMainShootInWrongPlace =
				newTaskInfo.eventType === 'MAIN_SHOOT' &&
				newTaskInfo.type !== 'PRODUCTION';

			if (isMainShootInWrongPlace && lastCorrectOrder) {
				$scope.lists = lastCorrectOrder;
			} else {
				$scope.lists = renewedList;
				$scope.lists = workflowService.renewTaskViewDue($scope.lists);
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/addWorkflowController.js